import { throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class CalendarEventService {
    private baseApiUrl: string;

    constructor (private configurationService: ConfigurationService, private httpClient: HttpClient) {
        this.baseApiUrl = this.configurationService.BaseApiUrl;
    }

    getCalendarEvents(branchId: number, month: Date): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `calendar/calendar?branchId=${branchId}&month=${month.toDateString()}`, ).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

  }
